import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/Button";

/**
 * A row of chips that jumps a long form to one of its sections.
 *
 * The resume review screens put the whole candidate form in one scroll pane, so
 * the recruiter needs a way to reach "Education" without hunting for it. Sits
 * either above the form or in the resume preview header — pass padding and
 * border classes through `className` to fit the surface it sits on.
 *
 * @param {Array<{key: string, label: string}>} sections
 * @param {(key: string) => void} onSectionClick
 * @param {string} [label] - leading text; pass "" to drop it
 */
const SectionJumpBar = ({ sections = [], onSectionClick, label = "Jump to", className = "" }) => {
  if (!onSectionClick || sections.length === 0) return null;

  return (
    <div className={cn("no-scrollbar flex items-center gap-1.5 overflow-x-auto", className)}>
      {label && <span className="shrink-0 text-[10px] font-bold uppercase tracking-wider text-text-muted">{label}</span>}

      {sections.map((section) => (
        <Button
          key={section.key}
          onClick={() => onSectionClick(section.key)}
          className="shrink-0 rounded-full border border-border-primary bg-background-tertiary px-2.5 py-1 text-[11px] text-text-secondary transition-colors hover:border-tone-blue/40 hover:bg-tone-blue-soft hover:text-tone-blue"
        >
          {section.label}
        </Button>
      ))}
    </div>
  );
};

export default SectionJumpBar;
